module.exports = __webpack_public_path__ + "img/postman-logo-horizontal-orange.7470f861.svg";